import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

const BASE = process.env.REACT_APP_BACKEND_URL;

async function call(path, method = "GET", body) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}${path}`, { method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) }, body: body ? JSON.stringify(body) : undefined });
    const j = await safeJson(r);
    if (!r.ok) throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`);
    return j;
}

export const fetchNotes = (id) => call(`/api/dossiers/${id}/notes`);
export const createNote = (id, payload) => call(`/api/dossiers/${id}/notes`, "POST", payload);
export const updateNote = (id, noteId, patch) => call(`/api/dossiers/${id}/notes/${noteId}`, "PATCH", patch);
export const deleteNote = (id, noteId) => call(`/api/dossiers/${id}/notes/${noteId}`, "DELETE");

export async function downloadNotePdf(id, noteId) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    if (!token) throw new Error("Session expirée, reconnectez-vous.");
    const r = await fetch(`${BASE}/api/dossiers/${id}/notes/${noteId}/pdf`, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) { const j = await safeJson(r); throw new Error(typeof j.detail === "string" ? j.detail : `Erreur ${r.status}`); }
    const blob = await r.blob();
    const name = (r.headers.get("Content-Disposition") || "").match(/filename="([^"]+)"/)?.[1] || "Note.pdf";
    const url = URL.createObjectURL(blob);
    const a = Object.assign(document.createElement("a"), { href: url, download: name });
    a.click();
    URL.revokeObjectURL(url);
}
